module.exports = __webpack_public_path__ + "static/media/embedded.fe144205.svg";